import { Avatar, Button, List, Spin, Typography } from 'antd'
import React from 'react'

import { UserSearch } from '@/components'
import { Role, useGetUsersQuery, useSystemAdminAddMutation, useSystemAdminRemoveMutation } from '@/generated/graphql'

export const AdminRoot = () => {
  const { data, loading, error, refetch } = useGetUsersQuery({
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
    variables: {
      filter: {
        role: Role.SystemAdmin,
      },
      pagination: {
        first: 1000,
      },
    },
  })

  const [addRole] = useSystemAdminAddMutation({
    onCompleted() {
      refetch()
    },
  })

  const [removeRole] = useSystemAdminRemoveMutation({
    onCompleted() {
      refetch()
    },
  })

  if (error || !data) {
    return null
  }

  if (loading) {
    return <Spin size='large' />
  }

  return (
    <div style={{ padding: 32, flex: '1 0 49%' }}>
      <List
        header={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography.Title level={5}>Admin</Typography.Title>
            <UserSearch
              renderAction={(userId: number) => (
                <Button
                  onClick={() =>
                    addRole({
                      variables: {
                        userId,
                      },
                    })
                  }
                >
                  添加
                </Button>
              )}
            >
              <Button>添加系统管理员</Button>
            </UserSearch>
          </div>
        }
        dataSource={data.users.edges.map(({ node }) => node)}
        renderItem={(u) => (
          <List.Item
            actions={[
              <Button
                key='remove'
                onClick={() =>
                  removeRole({
                    variables: {
                      userId: u.userId,
                    },
                  })
                }
              >
                去除系统管理员
              </Button>,
            ]}
          >
            <List.Item.Meta avatar={<Avatar src={u.avatarUrl} />} title={u.name}></List.Item.Meta>
          </List.Item>
        )}
      />
    </div>
  )
}
